import "@/styles/ServicesPage.css";
import { Home, Building2, Landmark, HardHat, Wrench, FileText } from "lucide-react";

const ServicesPage = () => {
  const services = [
    {
      icon: <Home size={40} />,
      title: "Construcción residencial",
      description: "Casas, apartamentos y conjuntos residenciales con diseños modernos y funcionales.",
      features: [
        "Diseño personalizado",
        "Materiales de calidad",
        "Acabados premium",
        "Entrega puntual"
      ],
      color: "orange"
    },
    {
      icon: <Building2 size={40} />,
      title: "Proyectos comerciales",
      description: "Oficinas y espacios comerciales adaptados a las necesidades del negocio.",
      features: [
        "Diseño funcional",
        "Espacios optimizados",
        "Tecnología integrada",
        "Cumplimiento normativo"
      ],
      color: "blue"
    },
    {
      icon: <Landmark size={40} />,
      title: "Obras institucionales",
      description: "Edificios públicos, escuelas y centros de salud con estándares especializados.",
      features: [
        "Normativas especiales",
        "Accesibilidad total",
        "Sostenibilidad",
        "Durabilidad máxima"
      ],
      color: "gray"
    },
    {
      icon: <HardHat size={40} />,
      title: "Dirección de obra",
      description: "Supervisión técnica profesional para garantizar calidad y cumplimiento.",
      features: [
        "Supervisión 24/7",
        "Control de calidad",
        "Gestión de cronograma",
        "Reportes detallados"
      ],
      color: "orange"
    },
    {
      icon: <Wrench size={40} />,
      title: "Remodelaciones",
      description: "Renovación y modernización de espacios con diseño contemporáneo.",
      features: [
        "Evaluación integral",
        "Diseño innovador",
        "Mínima interrupción",
        "Valor agregado"
      ],
      color: "blue"
    },
    {
      icon: <FileText size={40} />,
      title: "Consultoría técnica",
      description: "Asesoramiento especializado en construcción y desarrollo inmobiliario.",
      features: [
        "Análisis de viabilidad",
        "Optimización de costos",
        "Gestión de permisos",
        "Asesoría legal"
      ],
      color: "gray"
    }
  ];

  return (
    <div className="services-page" data-testid="services-page">
      <div className="services-hero">
        <div className="container">
          <h1 className="services-title fade-in-up" data-testid="services-title">
            Nuestros Servicios
          </h1>
          <p className="services-subtitle fade-in-up" data-testid="services-subtitle">
            Soluciones integrales para proyectos residenciales, comerciales e institucionales con la más alta calidad.
          </p>
        </div>
      </div>

      <div className="container section-padding">
        <div className="services-grid" data-testid="services-grid">
          {services.map((service, index) => (
            <div 
              key={index} 
              className={`service-card fade-in-up color-${service.color}`}
              style={{ animationDelay: `${index * 0.1}s` }}
              data-testid={`service-card-${index}`}
            >
              <div className="service-icon" data-testid={`service-icon-${index}`}>
                {service.icon}
              </div>
              <h3 className="service-title" data-testid={`service-title-${index}`}>
                {service.title}
              </h3>
              <p className="service-description" data-testid={`service-description-${index}`}>
                {service.description}
              </p>
              <ul className="service-features" data-testid={`service-features-${index}`}>
                {service.features.map((feature, fIndex) => (
                  <li key={fIndex} data-testid={`service-feature-${index}-${fIndex}`}>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="services-cta" data-testid="services-cta">
          <h2>¿Listo para comenzar tu proyecto?</h2>
          <p>Contáctanos y cuéntanos sobre tu visión. Estamos aquí para hacerla realidad.</p>
          <a href="/contacto" className="cta-button" data-testid="services-cta-btn">
            Solicitar Cotización
          </a>
        </div>
      </div>
    </div>
  );
};

export default ServicesPage;